import { Navigate, Outlet, useLocation } from 'react-router';
import { paths } from '../app/paths';
import { useMe } from '../auth/session';
import { useI18n } from '../i18n/i18n';
import { Spinner } from './ui/spinner';

/** Закрытые страницы: без сессии — на вход, с возвратом обратно после него. */
export function RequireAuth() {
  const { t } = useI18n();
  const me = useMe();
  const location = useLocation();
  if (me.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center">
        <Spinner label={t('common.loading')} />
      </div>
    );
  }
  if (me.data === null || me.data === undefined) {
    return (
      <Navigate
        to={paths.login}
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  return <Outlet />;
}
